import { BaseWithId } from '@app/shared/models/base';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export class Bank extends BaseWithId {
    public owner: string;
    public name: string;
    public iban: string;
    public bic: string;

    public trans = {
        owner: marker('bank.owner'),
        name: marker('bank.name'),
        iban: marker('bank.iban'),
        bic: marker('bank.bic')
    };

    constructor(json?: any) {
        super(json);
    }
}
